module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-health-b47e2cbd534816955068e6b32b5a0b8a.svg";